 
export class OpgavepakkeOpgave {
        public id: string;
        public opgavepakkeId: string;
        public opgaveId: string;
        public opgavetitel: string;
        public logbogId: string;
        public synligFoerKonkurrenceStart: boolean;
        public order: number;
        public uiId: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/OpgavepakkeOpgave.ts